import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RouteService } from '../outer-services/route.service';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
    constructor(private routeService: RouteService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401) {
                        try {
                            this.routeService.mainLogOut();
                        } catch (e) {
                            // fallback redirect
                            window.location.href = '/logout';
                        }
                        // swallow further processing
                        return throwError(err);
                    }
                }
                return throwError(err);
            })
        );
    }
}
